import { INFORMATION_VIEW_STATE_UPDATED } from '../actions/InformationViewActions';

// This is our apps initial state
// Since the initial state should never change, it is wrapped in a function to prevent unintended modification.
const getInitialState = () => {
  return {
    informationViewState: {
      property_expanded: false,
      protection_expanded: false,
      hazards_expanded: false,
      location_expanded: false,
      crime_expanded: false,
    },
  };
};

function InformationViewReducer(state = getInitialState(), action) {
  switch (action.type) {
    case INFORMATION_VIEW_STATE_UPDATED:
      return {
        ...state,
        informationViewState: Object.assign(
          state.informationViewState,
          action.informationViewState
        ),
      };
    default:
      return state;
  }
}

export default InformationViewReducer;
